import { createBrowserRouter } from 'react-router-dom';

import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import PublicRoutes from './PublicRoutes';

const router = createBrowserRouter([MainRoutes, LoginRoutes, PublicRoutes], { basename: import.meta.env.VITE_APP_BASE_NAME });

export default router;
